import { useTranslation } from "next-i18next";

import {
  NotificationsDock,
  NotificationStreamContextProvider,
  TransientNotificationsDisplayer,
  UserDrawer,
} from "@filadd/phi-plus-layout";
import { css } from "@filadd/phi-plus-styled-system/css";
import { Button } from "@filadd/phi-plus-core";

import type { ExpandedUserMeResponse } from "types/users/me";
import { GamificationTrinket } from "./GamificationTrinket";

interface Props {
  userData: ExpandedUserMeResponse | null;
  loginUrl: string;
  logoutUrl: string;
}

export const Navbar = ({ userData, loginUrl, logoutUrl }: Props) => {
  const { t } = useTranslation("notifications-dock");

  return userData ? (
    <div
      className={css({
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 1,
        overflowX: "hidden",
        pr: 1,
      })}
    >
      <NotificationStreamContextProvider
        streamURL={process.env.NOTIFICATIONS_STREAM_URL}
      >
        <NotificationsDock t={t} />
        <TransientNotificationsDisplayer />
      </NotificationStreamContextProvider>
      <GamificationTrinket />
      <UserDrawer
        name={userData.fullname}
        email={userData.email}
        avatar={userData.url_avatar}
        logoutCta={t("common:session.close")}
        logoutUrl={logoutUrl}
      />
    </div>
  ) : (
    <Button variant="ghost" size="sm">
      <a href={loginUrl}>{t("common:session.open")}</a>
    </Button>
  );
};
